import { render, staticRenderFns } from "./SmsTextEditor.vue?vue&type=template&id=53dab430&scoped=true"
import script from "./SmsTextEditor.vue?vue&type=script&lang=ts"
export * from "./SmsTextEditor.vue?vue&type=script&lang=ts"
import style0 from "./SmsTextEditor.vue?vue&type=style&index=0&id=53dab430&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dab430",
  null
  
)

export default component.exports